'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import BaseDrawer from '@mui/material/Drawer';
import { useMemo } from 'react';
const drawerWidth = 240;
export const Drawer = ({ anchor, open = false, variant = 'persistent', children }) => {
    const width = useMemo(() => {
        return open ? drawerWidth : 0;
    }, [open]);
    const styles = {
        root: {
            display: 'flex'
        },
        nav: {
            width: {
                sm: width
            },
            flexShrink: {
                sm: 0
            }
        },
        mobile: {
            display: {
                xs: 'block',
                sm: 'none'
            },
            '& .MuiDrawer-paper': {
                boxSizing: 'border-box',
                width
            }
        },
        drawer: {
            display: {
                xs: 'none',
                sm: 'block'
            },
            height: '100%',
            '& .MuiDrawer-paper': {
                boxSizing: 'border-box',
                width,
                height: '100%'
            },
            '& .MuiPaper-root': {
                position: 'static'
            }
        }
    };
    return (_jsx(Box, { sx: styles.root, children: _jsx(Box, { component: "nav", sx: styles.nav, children: _jsx(BaseDrawer, { variant: variant, sx: styles.drawer, open: true, anchor: anchor, children: _jsx(Box, { children: children }) }) }) }));
};
